var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"span",staticClass:"sm-text-truncate",class:[
    _vm.classes,
    {
      'show-hint': _vm.truncatedText,
    },
  ],style:({
    maxWidth: _vm.maxWidth,
  }),attrs:{"data-html":_vm.truncatedText},on:{"mousemove":_vm.checkHintPosition,"mouseleave":_vm.stopListeningToScroll,"mouseover":_vm.listenToScroll}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }